import { render, staticRenderFns } from "./MilestoneCreateComplete.vue?vue&type=template&id=115b9de6&scoped=true&"
import script from "./MilestoneCreateComplete.vue?vue&type=script&lang=js&"
export * from "./MilestoneCreateComplete.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneCreateComplete.vue?vue&type=style&index=0&id=115b9de6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b9de6",
  null
  
)

export default component.exports